import { Provider, User } from "@supabase/supabase-js";
import { supabase } from "../../configs/db.config";

export async function signUp(credentials: {
  email: string;
  password: string;
}): Promise<User | null> {
  try {
    const { email, password } = credentials;

    let {
      data: { user },
      error,
    } = await supabase.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: "/",
      },
    });

    if (error) throw new Error(error.message);

    return user;
  } catch (error: any) {
    throw new Error(error.message);
  }
}

export async function signIn(credentials: { email: string; password: string }) {
  try {
    const { email, password } = credentials;

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) throw new Error(error.message);
  } catch (error: any) {
    throw new Error(error.message);
  }
}

export async function signOut() {
  try {
    const { error } = await supabase.auth.signOut();

    if (error) throw new Error(error.message);
  } catch (error: any) {
    throw new Error(error.message);
  }
}

export async function signInWithOAuth(
  provider: Provider,
  redirectUrl: string = process.env.OAUTH_REDIRECT_URL!
) {
  try {
    const { error } = await supabase.auth.signInWithOAuth({
      provider,
      options: {
        redirectTo: redirectUrl,
      },
    });

    if (error) throw new Error(error.message);
  } catch (error: any) {
    throw new Error(error.message);
  }
}

export async function getAuthUser(): Promise<User | null> {
  try {
    const {
      data: { user },
      error,
    } = await supabase.auth.getUser();
    if (error) throw new Error(error.message);
    return user;
  } catch (error: any) {
    throw new Error("Error while fetching current user");
  }
}

export async function resetPasswordViaEmail(
  email: string,
  resetPasswordToken: string
) {
  try {
    if (!resetPasswordToken)
      throw new Error("Reset password token is required");
    if (!email) throw new Error("Email is required");
    const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${process.env.NEXT_PUBLIC_RESET_PASSWORD_REDIRECT_URL}/reset-password?token=${resetPasswordToken}`,
    });

    if (error) throw new Error(error.message);

    return data;
  } catch (error: any) {
    throw new Error(error.message);
  }
}
